import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import {
  getCartTypeFromPathname,
  serializeCartForSubmission,
  useCart,
} from '../../../cart/cart';

type CartFieldWrapperProps = {
  id: string;
  title?: string;
  description?: string;
  value?: string | null;
  onChange: (id: string, value?: string) => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  isDisabled?: boolean;
};

const CartFieldWrapper = (props: CartFieldWrapperProps) => {
  const { pathname } = useLocation();
  const cartType = getCartTypeFromPathname(pathname);
  const cart = useCart(cartType);
  const serializedCart = serializeCartForSubmission(cart);
  const { id, onChange, value } = props;
  const isOnEdit = value === null;

  useEffect(() => {
    if (!isOnEdit) {
      onChange(id, serializedCart);
    }
  }, [id, isOnEdit, onChange, serializedCart]);

  if (isOnEdit) {
    return (
      <FormFieldWrapper
        {...props}
        title={props.title || 'Warenkorb'}
        description={null}
        className="cart"
      >
        <p className="help">
          {props.description ||
            (cartType
              ? 'Der aktuelle Warenkorb wird mit dem Formular übermittelt.'
              : 'Das Warenkorb-Feld muss auf einer der beiden Warenkorbseiten verwendet werden.')}
        </p>
      </FormFieldWrapper>
    );
  }

  return (
    <input
      id={`field-${props.id}`}
      name={props.id}
      type="hidden"
      value={serializedCart}
      readOnly
    />
  );
};

export default CartFieldWrapper;
